import Service from "../service";
import AuthService from "../AuthService";

const Common = {
    getProvince(user_id) {
        return AuthService.get("/provinces?user_id="+user_id).then(res => res);
    },
    setProvince() {
        return Service.get("/set-provinces").then(res => res);
    },
    getDistrict(province_code){
        return Service.get('/districts?province_code='+province_code);
    },
    getSubDistrict(district_code){
        return Service.get('/sub_districts?district_code='+district_code);
    },
    getSubDistrictAuth(district_code){
        return AuthService.get('/sub_districts?district_code='+district_code);
    },
    getTypeWater(){
        return AuthService.get('/type_water');
    },
    getDepartments(){
        return AuthService.get('/departments');
    },
    getProvincePatient() {
      return AuthService.get('/province_patient');
    },
    getNation() {
      return AuthService.get('/nation');
    },
    getHospital(province_code) {
      return AuthService.get('/hospital?province_code='+province_code);
    }
};


export default Common;
